<template>
    <div>
        <input
                type="text"
                id="remite"
                name="remite"
                placeholder="Texto del remite"
                :value="computedValue"
                @change="onChange($event)"
        >&nbsp;
        <p>Se puede introducir un remite exacto (Ej: <b>trivago/pe</b>) o aproximado (Ej: <b>trivago*</b>)</p>
    </div>
</template>

<script>
    export default {
        name: 'remite-input',
        props: {
            selectedValue : {
                type: String
            }
        },
        data () {
            return {
                value : null,
            };
        },
        computed: {
            computedValue: function () {
                return this.value !== null ? this.value : this.selectedValue;
            }
        },
        methods: {
            onChange: function(event) {
                this.value = event.target.value;
                this.$emit('update', this.value);
            }
        }
    }
</script>